import React from "react";
import { LiveProvider, LivePreview, LiveError } from "react-live";
import RenderWidget from "./RenderWidget";
import Swal from "sweetalert2";
import * as KendoReactButtons from "@progress/kendo-react-buttons";
import * as KendoReactDropDowns from "@progress/kendo-react-dropdowns";
import * as KendoReactGrid from "@progress/kendo-react-grid";
import * as KendoReactLayout from "@progress/kendo-react-layout";
import * as KendoFileUploader from "@progress/kendo-react-upload";
import * as KendoReactDateInputs from "@progress/kendo-react-dateinputs";
import * as KendoReactPopup from "@progress/kendo-react-popup";
import * as KendoDataQuery from "@progress/kendo-data-query";
import * as KendoReactWindow from "@progress/kendo-react-dialogs";
import * as KendoReactInput from "@progress/kendo-react-inputs";
import * as KendoReactCharts from "@progress/kendo-react-charts";
import * as KendoReactMap from "@progress/kendo-react-map";
import * as KendoDrawing from "@progress/kendo-drawing";
import * as KendoExcelExport from "@progress/kendo-react-excel-export";

function ReactPreview(props) {
  let userProfile = props.core?.make("oxzion/profile").get().key;
  let previewCode = "";
  let jsxString = props.files[0]?.value;
  let scssString = props.files[1]?.value;
  if (jsxString !== "") {
    const styleString = `<style>
    ${"{`".concat(`.react-widget-${props.widget.uuid} { ${scssString} }`).concat("`}")}
  </style>`;
    let updatedCode = jsxString?.replace("<div>", `<div className="react-widget-${props.widget.uuid}">${styleString}`);
    previewCode = updatedCode ?? "";
  }

  return (
    <div className="react-preview-container">
      <LiveProvider
        disabled={props.disabled ? true : false}
        code={previewCode}
        scope={{
          ReactButtons: KendoReactButtons,
          ReactDropDowns: KendoReactDropDowns,
          ReactGrid: KendoReactGrid,
          ReactLayout: KendoReactLayout,
          FileUploader: KendoFileUploader,
          ReactDateInputs: KendoReactDateInputs,
          ReactPopup: KendoReactPopup,
          DataQuery: KendoDataQuery,
          ReactWindow: KendoReactWindow,
          ReactInput: KendoReactInput,
          ReactCharts: KendoReactCharts,
          ReactMap: KendoReactMap,
          ReactExcelExport: KendoExcelExport,
          ReactDrawing: KendoDrawing,
          Swal,
          baseUrl: props.core?.config("wrapper.url"),
          userProfile: userProfile,
          queryData: props.queryData,
          RenderWidget: (info) => {
            return RenderWidget(props, info);
          },
          makeApiCall: (url, params, method, raw) => {
            if (props.request.request) return props.request.request("v1", url, params, method);
            else return props.request.postDataRequest(url, params, method, raw);
          },
        }}
      >
        <LivePreview />
        <LiveError />
      </LiveProvider>
    </div>
  );
}

export default ReactPreview;
